import { render, staticRenderFns } from "./MonthlySummary.vue?vue&type=template&id=36fbab6f&scoped=true&"
import script from "./MonthlySummary.vue?vue&type=script&lang=js&"
export * from "./MonthlySummary.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySummary.vue?vue&type=style&index=0&id=36fbab6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbab6f",
  null
  
)

export default component.exports